namespace('compass.hotel');

compass.hotel.CustomGalleryCardWidget = compass.defineWidget(function CustomGalleryCardWidget(options) {
	var me = this;
	var d = jQuery.dom;
	var _settings = options;

	this.render = function(widgetElem) {
		var src = _settings.customGalleryCard;

		var customGalleryCardInner;
		if (src.link_url) {
			customGalleryCardInner = d.a({ className : 'customGalleryCardLink', href : src.link_url, 'target': '_blank' }, 
				d.img({ className : "customGalleryCardImage", src : src.graphic_url, alt : src.alt })
			);
		} else {
			customGalleryCardInner = d.img({ className : "customGalleryCardImage", src : src.graphic_url, alt : src.alt });
		}

		widgetElem.append(
			d.div({ className : 'customGalleryCard custom_gallery_card_id_' + src.custom_gallery_card_id, tabindex : 0, 'role': 'button', 'aria-role' : 'button', 'aria-labelled': src.custom_gallery_card_id },
				customGalleryCardInner
			)
		);
		widgetElem.activate(function() {
			me.trigger('CustomCard.clicked', {
				custom_gallery_card_id: _settings.customGalleryCard.custom_gallery_card_id,
				entered: _settings.customGalleryCard.entered,
				graphic_url: _settings.customGalleryCard.graphic_url,
				link_url: _settings.customGalleryCard.link_url,
				sort_order: _settings.customGalleryCard.sort_order,
				sort_section: _settings.customGalleryCard.sort_section
			});
		});
	};
}, {
	widgetName : 'CustomGalleryCardWidget'
});

